requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.data("xCustomMultipleStores", (perPage = 4, total = 0, mapZoom = 14) => ({
      mapZoom: mapZoom,
      mapSrc: "",
      perPage: perPage > 0 ? perPage : 4,
      total: total,
      search: "",
      visibleCount: perPage > 0 ? perPage : 4,
      matchedCount: -1,
      hasMore: total > (perPage > 0 ? perPage : 4),
      canCollapse: false,
      active: 1,
      open: false,
      canScroll: false,
      atTop: true,
      atBottom: false,
      load() {
        const canScrollVertically = this.$refs.list_stores.scrollHeight > this.$refs.list_stores.closest(".multi_stores_content").clientHeight;
        if (canScrollVertically) {
          this.canScroll = true;
        }
        window.addEventListener('resize', ()=> {
          this.heightNatural();
        })
        this.heightNatural();
        this.filterStores(false);
        this.updateMap();
        this.$watch("active", () => this.updateMap());
      },
      updateMap() {
        const current = this.storeItems().find((item) => parseInt(item.getAttribute("data-store-index"), 10) === parseInt(this.active, 10));
        const usesMap = current !== undefined && current.getAttribute("data-map") === "true";
        const address = current ? (current.getAttribute("data-address") || "").trim() : "";

        if (!usesMap || address === "") {
          this.mapSrc = "";
          return;
        }

        this.mapSrc = "https://maps.google.com/maps?q=" + encodeURIComponent(address) + "&t=m&z=" + this.mapZoom + "&ie=UTF8&output=embed&iwloc=near";
      },
      storeItems() {
        if (!this.$refs.list_stores) return [];
        return Array.from(this.$refs.list_stores.querySelectorAll(".store-item"));
      },
      filterStores(resetVisible = true) {
        if (resetVisible) {
          this.visibleCount = this.perPage;
        }
        const term = (this.search || "").replace(/\s+/g, " ").trim().toLowerCase();
        let matched = 0;
        let shown = 0;
        let firstVisibleIndex = null;
        let activeIsVisible = false;

        this.storeItems().forEach((item) => {
          const haystack = (item.getAttribute("data-search") || "").replace(/\s+/g, " ").trim();
          const isMatch = term === "" || haystack.indexOf(term) !== -1;
          let isVisible = false;

          if (isMatch) {
            matched++;
            if (shown < this.visibleCount) {
              isVisible = true;
              shown++;
            }
          }

          item.classList.toggle("store-item-hidden", !isVisible);

          if (isVisible) {
            const index = parseInt(item.getAttribute("data-store-index"), 10);
            if (firstVisibleIndex === null) firstVisibleIndex = index;
            if (index === parseInt(this.active, 10)) activeIsVisible = true;
          }
        });

        this.matchedCount = matched;
        this.hasMore = matched > shown;
        this.canCollapse = shown > this.perPage;

        if (!activeIsVisible && firstVisibleIndex !== null) {
          this.active = firstVisibleIndex;
        }

        this.$nextTick(() => {
          this.checkCanScrollVertical();
          this.heightNatural();
        });
      },
      loadMore() {
        this.visibleCount += this.perPage;
        this.filterStores(false);
      },
      viewLess() {
        this.visibleCount = this.perPage;
        this.filterStores(false);
        this.$nextTick(() => {
          if (this.$refs.list_stores) this.$refs.list_stores.scrollTop = 0;
          const firstVisible = this.storeItems().find((item) => !item.classList.contains("store-item-hidden"));
          if (firstVisible) {
            firstVisible.scrollIntoView({ behavior: "smooth", block: "nearest" });
          }
        });
      },
      clearSearch() {
        this.search = "";
        this.filterStores();
        if (this.$refs.store_search) this.$refs.store_search.focus();
      },
      heightNatural() {
        if (window.matchMedia("(min-width: 768px)").matches) {
          if(this.$refs.natural_height) {
             this.$refs.natural_height.style.height = this.$refs.h_img_location.offsetHeight +'px';
          }
        } else {
          if(this.$refs.natural_height) {
            this.$refs.natural_height.style.removeProperty('height');
          }
        }
      },
      openLocation(el) {
        this.open = true;
        var popupContent = document.getElementById(el.getAttribute("data-id"));

        this.$refs.content_location_detail.innerHTML = popupContent.innerHTML;
        const title = this.$refs.content_location_detail.querySelector('h5.location-title');
        if (title) {
          const h4 = document.createElement('h4');

          h4.innerHTML = title.innerHTML;
          h4.className = title.className;

          title.replaceWith(h4);
        }
      },
      hideLocation() {
        requestAnimationFrame(() => {
          this.open = false;
          Alpine.store('xPopup').open = false;
        });
      },
      scrollUp() {
        this.$refs.list_stores.scrollBy({
          top: -200,
          behavior: 'auto'
        });
        this.checkCanScrollVertical()
      },
      scrollDown() {
        this.$refs.list_stores.scrollBy({
          top: 200,
          behavior: 'auto'
        });
        this.checkCanScrollVertical()
      },
      checkCanScrollVertical() {
        if (!this.$refs.list_stores) return;
        const wrapper = this.$refs.list_stores.closest(".multi_stores_content");
        if (!wrapper) return;
        this.canScroll = this.$refs.list_stores.scrollHeight > wrapper.clientHeight;
        if (window.xViewport.innerWidth < 768) {
          this.atTop = this.$refs.list_stores.scrollTop === 0;
          this.atBottom = (this.$refs.list_stores.scrollTop + wrapper.clientHeight) >= (this.$refs.list_stores.scrollHeight - 2);
        }
      }
    }));
  });
});
